"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon/Icon"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Select = require("./Select.styles");

var _excluded = ["options", "text", "size", "backgroundColor", "action", "disabled", "dataTestId"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = function Select(_ref) {
  var _props$defaultValue$v, _props$defaultValue, _props$defaultValue$t, _props$defaultValue2;

  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [{
    text: 'Pate',
    value: 'pate'
  }, {
    text: 'Cafe',
    value: 'cafe'
  }, {
    text: 'Sardina',
    value: 'sardina'
  }] : _ref$options,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Seleccione una opción' : _ref$text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'gray' : _ref$backgroundColor,
      action = _ref.action,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-select' : _ref$dataTestId,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleAction = function handleAction(event) {
    if (typeof action === 'function') action(event);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Select.Occ_SelectContainer, {
    disabled: disabled,
    "data-test-id": dataTestId,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_Select.Occ_SelectIcon, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "dropdown"
  })), /*#__PURE__*/_react["default"].createElement(_Select.Occ_Select, {
    onChange: function onChange(e) {
      return handleAction(e);
    },
    backgroundColor: backgroundColor,
    name: props.name
  }, /*#__PURE__*/_react["default"].createElement(_Select.Occ_SelectOption, {
    value: (_props$defaultValue$v = (_props$defaultValue = props.defaultValue) === null || _props$defaultValue === void 0 ? void 0 : _props$defaultValue.value) !== null && _props$defaultValue$v !== void 0 ? _props$defaultValue$v : '',
    disabled: true,
    hidden: true,
    selected: true
  }, (_props$defaultValue$t = (_props$defaultValue2 = props.defaultValue) === null || _props$defaultValue2 === void 0 ? void 0 : _props$defaultValue2.text) !== null && _props$defaultValue$t !== void 0 ? _props$defaultValue$t : text), options && options.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Select.Occ_SelectOption, {
      key: index,
      value: item.value
    }, item.text);
  }))));
};

var _default = Select;
exports["default"] = _default;